const hotel = {
  availableMealPlans: "Galimi maitinimo planai", // translated 
  availableRoomsTypes: "Galimi kambarių tipai", // translated 
  cancellationPolicy: "Atšaukimo politika", // translated 
  cancellationRules: "Atšaukimo taisyklės", // translated 
  freeCancellationAvailable: "Galimas nemokamas atšaukimas", // translated 
  nonRefundable: "Negrąžinamas", // translated 
  priceFor: "Kaina už", // translated 
  nights: "naktys", // translated 
  totalPrice: "Bendra kaina", // translated 
  seeAvailability: "Žr. Prieinamumas", // translated 
  myProfile: "Mano profilis", // translated 
  travelTrust: "Kelionių trestas", // translated 
  signIn: "Prisijungti", // translated 
  searchNow: "Ieškokite dabar", // translated 
  policy: "politika", // translated 
  cxlRules: "CXL taisyklės", // translated 
  room: "kambarys", // translated 
  cxlPolicy: "CXL politika", // translated 
  beddingType: "Patalynės tipas", // translated 
  hotelName: "Viešbučio pavadinimas", // translated 
  reservationDate: "Rezervacijos data", // translated 
  maxPax: "Maksimas Paksas", // translated 
};



export default hotel;
